import { LoginRequest } from "../daos/requests/login_request";
import { LoginResponse } from "../daos/responses/login_response";
import { IAuthService } from "./auth_service";
import { axiosInstance } from "../../../../common/utils/axios_instance";
import { handleAxiosResponse } from "../../../../common/utils/axios_response";
import { EnterpriseDao, GetEnterprisesResponse } from "../daos/responses/get_entreprises_response";
import { ConfigureLoginRequest } from "../daos/requests/configure_login_request";
import { ConfigureLoginResponse } from "../daos/responses/configure_login_response";
import { AxiosError } from "axios";
import { LoginAvailableRequest } from "../daos/requests/login_available_request";
import { EsqueceuSuaSenhaRequest, EsqueceuSuaSenhaResponse } from "../daos/update/esqueceu_sua_senha";
import { isBaseError, toBaseError } from "../../../../common/utils/base_error";
import { TrocarSenhaRequest, TrocarSenhaResponse } from "../daos/update/trocar_senha";

/**
 * AuthService
 */

export class AuthService implements IAuthService {
  async esqueceuSuaSenha(request: EsqueceuSuaSenhaRequest): Promise<EsqueceuSuaSenhaResponse> {
    try {
      const result = await axiosInstance({ checkAuthentication: false }).post(`/usuario/esqueceu-sua-senha`, request);
      const response = handleAxiosResponse<EsqueceuSuaSenhaResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async login(request: LoginRequest): Promise<LoginResponse> {
    try {
      const result = await axiosInstance({ checkAuthentication: false }).post(`/usuario/login`, request);
      const response = handleAxiosResponse<LoginResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getEnterprises(): Promise<GetEnterprisesResponse> {
    try {
      const result = await axiosInstance({ checkAuthentication: false }).get<EnterpriseDao[]>(`/empresa`)
      return { enterprises: handleAxiosResponse<EnterpriseDao[]>(result) };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async configureLogin(request: ConfigureLoginRequest): Promise<ConfigureLoginResponse> {
    try {
      const response = await axiosInstance({ checkAuthentication: false }).post(`/usuario/configure`, request);
      if (response.status === 200) {
        return { existing: false, goToLastStep: true };
      }
      else if (response.status === 400) {
        return { existing: false, goToThirdStep: true };
      }
      else if (response.status === 401) {
        return { existing: true, message: response.data["Message"] ?? "Ocorreu um erro inesperado." };
      }
      else if (response.status === 405) {
        return { existing: true, goToLastStep: true };
      }
      return { existing: true, message: response.data["Message"] ?? "Ocorreu um erro inesperado." };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async loginAvailable(request: LoginAvailableRequest): Promise<boolean> {
    try {
      const response = await axiosInstance({ checkAuthentication: false }).post(`/usuario/login-available`, request)
      return response.status === 200;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async trocarSenha(request: TrocarSenhaRequest): Promise<TrocarSenhaResponse> {
    try {
      const result = await axiosInstance({ checkAuthentication: false }).post(`/usuario/trocar-senha`, request);
      const response = handleAxiosResponse<TrocarSenhaResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
}